<template>
  <div class="referred">
    <v-card-text>
      <div style="margin-bottom: 50px">
        <div class="req-list">
          <div class="req-card">
            <div>
              <v-select
                outlined
                label="نوع محصول"
                :items="product_types"
                single-line
                item-text="ProductTypeTitle"
                item-value="Id"
                v-model="selected_product_types"
              />
              <v-select
                outlined
                label="دسته محصول"
                :items="product_cats"
                single-line
                item-text="CategoryTitle"
                item-value="Id"
                v-model="selected_product_cats"
              />
              <v-select
                outlined
                label="گروه محصول"
                :items="product_groups"
                single-line
                item-text="CategoryGroupTitle"
                item-value="Id"
                v-model="selected_product_groups"
              />
              <v-select
                outlined
                label="خصوصیات محصول"
                :items="product_details"
                single-line
                chips
                multiple
                item-text="ItemTitle"
                item-value="ItemId"
                v-model="selected_product_details"
              />
              <v-select
                outlined
                label="برند محصول"
                :items="product_brands"
                single-line
                item-text="SubGroupTitle"
                item-value="Id"
                v-model="selected_product_brands"
              />
              <div style="border: 1px solid grey;border-radius: 3px;margin-bottom: 3px;padding: 5px" @click="dialog_model=true">مدل دستگاه : {{product_model_title}}</div>
              <v-textarea
                outlined
                placeholder="توضیحات"
                v-model="description"/>
              <div>{{ product_name }}</div>
            </div>

          </div>

        </div>
      </div>

    </v-card-text>
    <v-btn color="primary"

           style="font-weight:bold;border-radius: 0px; height: 45px;margin-top: 10px"
           class="enter-btn footer_btn" v-on:click="insert_pre_product()">
      افزودن کالا
    </v-btn>
    <v-dialog
      v-model="dialog_model"
      max-width="290"
      fullscreen
      hide-overlay
    >

      <v-card class="category-modal">
        <v-card-title class="headline">
          {{$t('deviceModel')}}
        </v-card-title>
        <v-card-text>
          <v-row>

            <treeselect
              :multiple="false"
              :load-options="load_models"
              :normalizer="normalizer_models"
              :async="true"

              :placeholder="$t('searchDeviceModel')"
              v-model="product_model_id"
            />

          </v-row>
          <br>
          <br>
          <br>
          {{$t('selectedModel')}}

          <label>{{product_model_title}}</label>

        </v-card-text>
        <v-card-actions class="">
          <v-spacer></v-spacer>

          <v-btn
            class="cancle-btn"
            text
            @click="dialog_model = false"
          >
            {{$t('ok')}}
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>

</template>
<script>
import Treeselect, {ASYNC_SEARCH} from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

import axios from 'axios'
import Vue from 'vue'

import {bus} from '../../main'

const simulateAsyncOperation = fn => {
  setTimeout(fn, 200)
}
export default {
  props: [
    'passing_data'
  ],
  data() {
    return {
      dialog_model:false,
      description: '',
      product_types: [],
      product_cats: [],
      product_groups: [],
      product_brands: [],
      product_details: [],
      selected_product_types: 0,
      selected_product_cats: 0,
      selected_product_groups: 0,
      selected_product_brands: 0,
      selected_product_details: [],
      product_name: '',
      product_model_id: 0,
      product_model_title: "",
      normalizer_models (node) {
        return {
          id: node.Id,
          label: node.Title,
        }
      },
      search_entries: [],

    }
  },
  computed: {},
  components: {Treeselect},
  watch: {
    product_model_id () {
      for (var i = 0; i < this.search_entries.length; i++) {
        if (this.search_entries[i].Id == this.product_model_id) {
          this.product_model_title = this.search_entries[i].Title
        }
      }
    },
    selected_product_types: function () {
      this.get_product_cats()
      this.generate_product_name()
    },
    selected_product_cats: function () {
      this.get_product_groups()
      this.generate_product_name()
    },
    selected_product_groups: function () {
      this.get_product_brands()
      this.get_product_details()
      this.generate_product_name()
    },
    selected_product_brands: function () {
      this.generate_product_name()
    },
    selected_product_details: function () {
      this.generate_product_name()
    },
    product_model_title: function () {
      this.generate_product_name()
    },
  },
  mounted() {
    this.get_product_type()
  },

  methods: {
    load_models ({ action, searchQuery, callback }) {
      this.product_model_title = searchQuery
      var self = this
      if (action === ASYNC_SEARCH) {
        simulateAsyncOperation(() => {
          let options

          var passing_data = JSON.parse(localStorage.getItem('request_data'))

          const send_data = {
            txt: searchQuery,
            sgid: this.selected_product_brands,
          }
          this.axios.post('/GetProductModels', send_data, {})
            .then(response => {
              self.search_entries = response.data.results
              options = response.data.results
              callback(null, options)
              // this.$router.push({ path: "/post-login", params: {} });
            }).catch(e => {
            this.errors.push(e)
          })

          //
          // axios.post('/api/admin/product_search-tags', {
          //   search: searchQuery,
          //
          // }).then(function (response) {
          //   options = response.data;
          //   callback(null, options);
          //   // localStorage.setItem("api_token", response.data.access_token);
          //   // self.$router.push({ path: 'notes' });
          // })
          //   .catch(function (error) {
          //     self.message = 'Incorrect E-mail or password';
          //     self.showMessage = true;
          //     console.log(error);
          //   });

          //  const options = this.get_keywords(searchQuery);
          // const options = [1, 2, 3, 4, 5].map(i => ({
          //     id: `${searchQuery}-${i}`,
          //     name: `${searchQuery}-${i}`,
          // }))
        })
      }
    },

    generate_product_name() {
      var self = this
      try {
        const group_name = this.product_groups.filter(x => x.Id == this.selected_product_groups)[0].CategoryGroupTitle || '';
        const brand_name = this.product_brands.filter(x => x.Id == this.selected_product_brands)[0].SubGroupTitle || '';
        this.product_name =
          ' ' + group_name
        this.selected_product_details.forEach(function (val) {
          self.product_name += " " + self.product_details.filter(x => x.ItemId == val)[0].ItemTitle
        })
        this.product_name += " " + brand_name
        this.product_name += " " + this.product_model_title
      } catch (e) {
        console.log(e)
      }

    },
    get_product_type() {
      var self = this
      const send_data = {}
      // this.axios.post('/Register' , send_data,{
      this.axios.post('/GetProductTypeList', send_data, {})
        .then(response => {
          if (response.data.error == 0) {
            self.product_types = response.data.Types
            self.selected_product_types = self.product_types[0].Id
          }
        }).catch(e => {
        this.errors.push(e)
      })
    },
    get_product_cats() {
      var self = this
      const send_data = {
        pTypeId: this.selected_product_types,
      }
      this.axios.post('/GetReqTypeCategoryByTypeId', send_data, {})
        .then(response => {
          if (response.data.error == 0) {
            self.product_cats = response.data.categories
            self.selected_product_cats = self.product_cats[0].Id

          }
        }).catch(e => {
        this.errors.push(e)
      })
    },
    get_product_groups() {
      var self = this
      const send_data = {
        catId: this.selected_product_cats,

      }
      this.axios.post('/GetReqCategoryGroupListRelByCatId', send_data, {})
        .then(response => {
          if (response.data.error == 0) {
            self.product_groups = response.data.groups
            self.selected_product_groups = self.product_groups[0].Id

          }
        }).catch(e => {
        this.errors.push(e)
      })
    },
    get_product_brands() {
      var self = this
      const send_data = {
        groupId: this.selected_product_groups,
      }
      // this.axios.post('/Register' , send_data,{
      this.axios.post('/GetReqCategorySubGroupListRelByGrpId', send_data, {})
        .then(response => {
          if (response.data.error == 0) {
            self.product_brands = response.data.subGroups
            self.selected_product_brands = self.product_brands[0].Id

          }
        }).catch(e => {
        this.errors.push(e)
      })
    },
    get_product_details() {
      var self = this
      const send_data = {
        grpId: this.selected_product_groups
      }
      // this.axios.post('/Register' , send_data,{
      this.axios.post('/GetProductGroupDetailsByKeyword', send_data, {})
        .then(response => {
          if (response.data.error == 0) {
            self.product_details = response.data.Types
            self.selected_product_details = []
          }
        }).catch(e => {
        this.errors.push(e)
      })
    },
    insert_pre_product() {

      var self = this
      let details = []
      this.selected_product_details.forEach(function (val){
        const det = self.product_details.filter(x => x.ItemId == val)[0]
details.push(det);
      })
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId

      const json ={
        UserId:user_id,
        ProductTypeId:this.selected_product_types,
        CategoryId:this.selected_product_cats,
        GroupIdd:this.selected_product_groups,
        SubGroupId:this.selected_product_brands,
        ProductUnitId:1,
        ProductName:this.product_name,
        ModelId:this.product_model_id,
        ModelTitle:this.product_model_title,
        Description:this.description,
        GrpDetailValue:JSON.stringify(details)
      }

      // this.axios.post('/Register' , send_data,{
      this.axios.post('/AddPreProduct', json, {})
        .then(response => {
          bus.$emit('show_toast', [1500, response.data.msg])

          if (response.data.error == 0) {
            self.$router.go(-1)
          }
        }).catch(e => {
        this.errors.push(e)
      })
    },
  }
}
</script>
